import React from 'react';
import classnames from 'classnames';
import styles from './section.module.scss';

interface SectionProps {
  title: string;
  position?: 'left' | 'center';
  className?: string;
  children?: React.ReactNode;
  customRight?: React.ReactNode;
}

export const Section: React.FC<SectionProps> = ({
  title,
  position,
  customRight,
  className,
  children,
}) => {
  return (
    <section className={styles.section}>
      <div className='mb-2 mt-10 flex items-center gap-2'>
        <h2 className={styles['section--title']}>{title}</h2>
        {customRight}
      </div>
      <div className={classnames(styles['section--content'], className)}>
        <div
          className={
            styles[`section--container-${position ? position : 'left'}`]
          }
        >
          {children}
        </div>
      </div>
    </section>
  );
};
